<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock Returns",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Stock Returns",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Returns",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "agent",
          sortable: true,
          label: "AGENT",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED By",
        },
        {
          key: "date",
          sortable: true,
          label: "RETURNED ON",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTION",
        }
      ],

      // delete data
      deletedata: {
          name: "",
          id: "",
          agent: "",
      },
      // Confirm stock return data
      confirmdata: {
        name: "",
        id: "",
        agent: "",
      },
      //Reject stock return record
      rejectdata: {
          name: "",
          id: "",
          agent: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("agentstock", ["SaveStatus", "Stockreturns"]),
    ...mapGetters("auth", ["MyUserPerm","User"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Stockreturns ? this.Stockreturns.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Stockreturns ? this.Stockreturns.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStockReturn: "agentstock/fetchAgentstockReturns",
      ConfirmStockReturn: "agentstock/ConfirmStockreturn",
      DeleteStockReturn: "agentstock/DeleteStockreturn",
      RejectStockReturn: "agentstock/RejectStockreturn",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }, 
    
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
          this.$bvModal.hide(modalId);
      });
    },
    
    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.deletedata.agent = "";
      this.modal_id = "";
      },
    resetConfirm() {
      this.confirmdata.name = "";
      this.confirmdata.id = "";
      this.confirmdata.agent = "";
      this.modal_id = "";
    },
    resetReject() {
      this.rejectdata.name = "";
      this.rejectdata.id = "";
      this.rejectdata.agent = "";
      this.modal_id = "";
    },

    // Confirm stock return
    confirmReturn(modalId) {
      this.modal_id = modalId;
      this.ConfirmStockReturn(this.confirmdata);
    },

    showConfirmModal(data) {
      this.confirmdata.name = data.item.product;
      this.confirmdata.id = data.item.id;
      this.confirmdata.agent = data.item.agent;
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.product;
      this.deletedata.id = data.item.id;
      this.deletedata.agent = data.item.agent;
    },
    deleteReturn(modalId) {
      this.modal_id = modalId;
      this.DeleteStockReturn(this.deletedata);
    },

    // Reject stock return
    rejectReturn(modalId) {
      this.modal_id = modalId;
      this.RejectStockReturn(this.rejectdata);
    },

    showRejectModal(data) {
      this.rejectdata.name = data.item.product;
      this.rejectdata.id = data.item.id;
      this.rejectdata.agent = data.item.agent;
    },
    
  },
  created() {
    this.FetchStockReturn();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Stockreturns?Stockreturns:[]"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(actions)="data">
                <b-button-group>
                  <b-button v-if="User.role.delete_stock_returns == 1 && User.is_agent == 'No' && data.item.status == 'Pending'"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete_stockreturns-modal
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i>
                  </b-button>
                  <b-button v-if="User.role.confirm_stock_returns == 1 && User.is_agent == 'No' && data.item.status == 'Pending'"
                      size="sm"
                      variant="success"
                      v-b-modal.confirm_stockreturns-modal
                      @click="showConfirmModal(data)"
                  ><i class="fa fa-check"></i>Confirm</b-button>
                  <b-button v-if="User.role.confirm_stock_returns == 1 && User.is_agent == 'No' && data.item.status == 'Pending'"
                      size="sm"
                      variant="warning"

                      v-b-modal.reject_stockreturns-modal
                      @click="showRejectModal(data)"
                  ><i class="fa fa-cross"></i>Reject
                  </b-button>
                  <span class="text-info" v-if="User.is_agent == 'Yes' && data.item.status == 'Pending'">Pending</span>
                  <span class="text-success" v-if="data.item.status == 'Approved'">Confirmed</span>
                  <span class="text-warning" v-if="data.item.status == 'Rejected'">Rejected</span>
                </b-button-group>
              </template>
              </b-table>
              <!-- modal confirm stock return starts -->
              <b-modal
                  header-bg-variant="warning"
                  header-text-variant="warning"
                  body-text-variant="warning"
                  footer-bg-variant="warning"
                  footer-text-variant="warning"
                  id="reject_stockreturns-modal"
                  hide-footer
                  @hidden="resetConfirm"
              >
                <template #modal-title> Reject stock return for product {{ rejectdata.name }} by agent {{  }}</template>
                <div class="form-group mb-3">
                  <div class="input-group">
                    <h5>
                      Do you want to reject this stock return record? Click Proceed Button to confirm.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="closeModal('reject_stockreturns-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                      type="button"
                      class="btn btn-warning"
                      @click="rejectReturn('reject_stockreturns-modal')"
                  >
                    <i class="fa fa-trash"></i> Proceed
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Rejecting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
          
              <!-- modal confirm stock return starts -->
              <b-modal
                  header-bg-variant="success"
                  header-text-variant="light"
                  body-text-variant="success"
                  footer-bg-variant="success"
                  footer-text-variant="success"
                  id="confirm_stockreturns-modal"
                  hide-footer
                  @hidden="resetConfirm"
              >
                <template #modal-title> Confirm stock return for product {{ confirmdata.name }} by agent {{  }}</template>
                <div class="form-group mb-3">
                  <div class="input-group">
                    <h5>
                      Do you want to confirm this stock return record? Click Proceed Button to confirm.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="closeModal('confirm_stockreturns-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                      type="button"
                      class="btn btn-success"
                      @click="confirmReturn('confirm_stockreturns-modal')"
                  >
                    <i class="fa fa-check"></i> Proceed
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Confirming"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
              <!-- modal confirm stock return starts -->
              <b-modal
                  header-bg-variant="danger"
                  header-text-variant="light"
                  body-text-variant="danger"
                  footer-bg-variant="danger"
                  footer-text-variant="danger"
                  id="delete_stockreturns-modal"
                  hide-footer
                  @hidden="resetConfirm"
              >
                <template #modal-title>Delete stock return for {{ deletedata.name }} by {{  }}</template>
                <div class="form-group mb-3">
                  <div class="input-group">
                    <h5>
                      Do you want to delete this stock return record? Click Proceed Button to confirm.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-light"
                      data-dismiss="modal"
                      @click="closeModal('delete_stockreturns-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                      type="button"
                      class="btn btn-danger"
                      @click="deleteReturn('delete_stockreturns-modal')"
                  >
                    <i class="fa fa-trash"></i> Proceed
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Confirming"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
            </div>
            <Loader  v-if="!Stockreturns"/>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
